import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import Joi from 'joi'

export default Joi.object({
  businessLine: Joi.string().required(),
  businessLineId: Joi.string().required(),
  maxInsurances: Joi.number().integer().min(0).required(),
  maxDays: Joi.number().integer().min(0).required(),
  hiringMaxAges: Joi.object({
    holderInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    holderNotInsured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required(),
    insured: Joi.object({
      min: Joi.string().required(),
      max: Joi.string().required()
    }).required()
  }).required(),
  hiringEndDateStudent: Joi.object({
    time: Joi.string().required(),
    min: Joi.string().required(),
    max: Joi.string().required()
  }).required(),
  billingCyclesStudent: Joi.object({
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().allow(''),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  billingCyclesResident: Joi.object({
    annual: Joi.object({
      id: Joi.string().required(),
      textInFilter: Joi.string().allow(''),
      textInPrice: Joi.string().required(),
      discountText: Joi.string().allow(''),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  genders: Joi.object({
    female: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    male: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  houseTypes: Joi.object({
    apartment: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required(),
    house: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required()
    }).required()
  }).required(),
  insuranceTypes: Joi.object({
    student: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required(),
    resident: Joi.object({
      id: Joi.string().required(),
      text: Joi.string().required(),
      default: Joi.boolean().required(),
      disabled: Joi.boolean().required()
    }).required()
  }).required(),
  tags: Joi.object({
    personalDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    contactDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    personalDataInsuredAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    allYearPassedDateAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    moreInfoStudyAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    moreInfoLiveAlert: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    startDateTooltip: Joi.object({
      label: Joi.string().required()
    }),
    endDateTooltip: Joi.object({
      label: Joi.string().required()
    }).required(),
    durationAlertStudent: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    durationAlertStudentMediator: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }),
    durationAlertResident: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    }).required(),
    durationAlertResidentMediator: Joi.object({
      label: Joi.string().required(),
      icon: Joi.string().required()
    })
  }).required()
})
  .error((errors) => {
    const text = `DXP Foreign Health branch configuration - ${errors
      .map((e) => `"${e.local.label}" is required`)
      .join()}`
    console.error(text)
    return new ConsoleError({ message: text })
  })
  .unknown(true)
